'use client';
import { useButton } from '@react-aria/button';
import e__default from 'react';
import { useFloatingLabelTextInputElement } from '../../contexts/internal/floating-label/index.js';
import { useSwanComboboxContext } from './combobox.context.js';
import { TextInput } from '../text-input/text-input.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { className } from '../../../core/utilities/classnames.utils.js';
import { RenderComp } from '../core/render-comp.component.js';
import { Button } from '../button/button.component.js';
import { Icon } from '../icon/icon.component.js';
import { assignRefs } from '../../../core/utilities/ref.utils.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r.push.apply(r, o);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var c = Object.getOwnPropertySymbols(e);
        for(o = 0; o < c.length; o++)r = c[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, c = Object.keys(e);
    for(o = 0; o < c.length; o++)r = c[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
const ComboboxInput = renderWithRef('ComboboxInput', {}, (c, s)=>{
    let { buttonRef: u, buttonProps: f, inputRef: _, inputProps: m, menuTrigger: j } = useSwanComboboxContext(), { buttonProps: y } = useButton(_object_spread_props(_object_spread({}, f), {
        isDisabled: c.disabled
    }), u), O = assignRefs(s, _), d = useFloatingLabelTextInputElement(_object_spread_props(_object_spread({}, m, c), {
        onBlur: (e)=>{
            var t, r;
            null === (t = c.onBlur) || void 0 === t || t.call(c, e), null === (r = m.onBlur) || void 0 === r || r.call(m, e);
        },
        className: className(c.className, 'swan-input swan-combobox')
    })), g = _object_without_properties(y, [
        'aria-label'
    ]);
    return g['aria-hidden'] = !0, e__default.createElement(e__default.Fragment, null, e__default.createElement(RenderComp, {
        forwardedRef: O,
        root: TextInput,
        props: _object_spread_props(_object_spread({}, d), {
            type: 'text'
        })
    }), 'focus' === j && e__default.createElement(Button, _object_spread_props(_object_spread({
        ref: u
    }, g), {
        className: "swan-combobox-button",
        skin: "tertiary"
    }), e__default.createElement(Icon, {
        iconType: "caretDown"
    })));
});

export { ComboboxInput };
